var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.797 10.53a1.368 1.368 0 00-.25-.02H6.44l.308-.15c.301-.15.575-.354.808-.601l3.957-4.154a1.614 1.614 0 00.207-1.99 1.43 1.43 0 00-.408-.396 1.388 1.388 0 00-1.085-.176 1.396 1.396 0 00-.653.376l-7.155 7.506C2.15 11.21 2 11.591 2 11.988c0 .396.15.777.42 1.062l7.154 7.51a1.376 1.376 0 002.024 0c.044-.046.086-.095.125-.146a1.614 1.614 0 00-.208-1.991l-3.951-4.164c-.21-.22-.45-.405-.715-.548l-.429-.203h14.051c.357.01.706-.11.983-.342a1.54 1.54 0 00.527-.92 1.532 1.532 0 00-.25-1.108 1.452 1.452 0 00-.934-.609z"
  })));
}
export default SvgArrowLeftIcon;